import React, { useState, memo } from 'react';
import { Upload, X } from 'lucide-react';
interface ImageUploadProps {
  maxImages?: number;
  onImagesChange: (images: File[]) => void;
}
const ImageUpload: React.FC<ImageUploadProps> = ({
  maxImages = 3,
  onImagesChange
}) => {
  const [images, setImages] = useState<File[]>([]);
  const [previews, setPreviews] = useState<string[]>([]);
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      const newImages = [...images, ...selectedFiles].slice(0, maxImages);
      setImages(newImages);
      onImagesChange(newImages);
      // Create previews
      const newPreviews = newImages.map(file => URL.createObjectURL(file));
      // Revoke old preview URLs to avoid memory leaks
      previews.forEach(url => URL.revokeObjectURL(url));
      setPreviews(newPreviews);
    }
  };
  const removeImage = (index: number) => {
    const newImages = [...images];
    const newPreviews = [...previews];
    // Revoke the URL of the removed preview
    URL.revokeObjectURL(previews[index]);
    newImages.splice(index, 1);
    newPreviews.splice(index, 1);
    setImages(newImages);
    setPreviews(newPreviews);
    onImagesChange(newImages);
  };
  return <div className="w-full" data-id="element-71">
      <div className="flex flex-wrap gap-4 mb-4" data-id="element-72">
        {previews.map((preview, index) => <div key={index} className="relative" data-id="element-73">
            <img src={preview} alt={`Preview ${index + 1}`} className="w-24 h-24 object-cover rounded-lg border border-gray-200" data-id="element-74" />
            <button type="button" onClick={() => removeImage(index)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1" data-id="element-75">
              <X className="h-4 w-4" data-id="element-76" />
            </button>
          </div>)}
      </div>
      {images.length < maxImages && <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100" data-id="element-77">
          <div className="flex flex-col items-center justify-center pt-5 pb-6" data-id="element-78">
            <Upload className="w-8 h-8 text-gray-400 mb-2" data-id="element-79" />
            <p className="mb-2 text-sm text-gray-500" data-id="element-80">
              <span className="font-semibold" data-id="element-81">Click to upload</span> or drag and
              drop
            </p>
            <p className="text-xs text-gray-500" data-id="element-82">
              PNG, JPG, or WEBP (max {maxImages} images)
            </p>
          </div>
          <input type="file" className="hidden" accept="image/*" multiple={maxImages > 1} onChange={handleImageChange} data-id="element-83" />
        </label>}
      {images.length > 0 && <p className="text-sm text-gray-500 mt-2" data-id="element-84">
          {images.length} of {maxImages} images uploaded
        </p>}
    </div>;
};
export default ImageUpload;